import React, { useEffect, useState } from 'react';
import classes from "./SubscriptionPage.module.css";
import Layout from '../components/Layout';
import { allPublisherApi, getServicesApi, getSubscriptionApi, getTrafficApi } from '../http/http';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Spinner from '../components/Spinner';
import { removeToken } from '../store/slices/tokenSlice';
import { toast } from 'react-toastify';
import { Dropdown } from 'primereact/dropdown';
import moment from "moment";
import { Calendar } from "primereact/calendar";
import { Message } from 'primereact/message';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import date from '../utils/date';

const SubscriptionPage = () => {
    const [services, setServices] = useState([]);
    const [service, setService] = useState(null);
    const [publishers, setPublishers] = useState([]);
    const [publisher, setPublisher] = useState(null);
    const [filteredPublishers, setFilteredPublishers] = useState([]);

    const [subscription, setSubscription] = useState([]);

    const [startDate, setStartDate] = useState(
        moment(new Date()).format("yyyy-MM-DD")
    );
    const [endDate, setEndDate] = useState(
        moment(new Date()).format("yyyy-MM-DD")
    );

    const [startDateForCalendar, setStartDateForCalendar] = useState(new Date());
    const [endDateForCalendar, setEndDateForCalendar] = useState(new Date());

    // DATE CONVERTION FUNCTIONS..
    const convertStartDate = (utcDate) => {
        setStartDateForCalendar(utcDate);
        setStartDate(moment(new Date(utcDate)).format("yyyy-MM-DD"));
    };

    const convertEndDate = (utcDate) => {
        setEndDateForCalendar(utcDate);
        setEndDate(moment(new Date(utcDate)).format("yyyy-MM-DD"));
    };

    const { token } = useSelector(state => state?.tokenSlice);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);

    const getServices = async () => {
        try {
            setLoading(true);
            const response = await getServicesApi(token);
            setServices([{ service_name: "All" }, ...response?.data?.services]);
            setService("All");
            setLoading(false);

        } catch (error) {
            setLoading(false);
            if (error?.response?.status == 403) {
                dispatch(removeToken());
                toast.error("Login Again!");
                navigate('/');
            }
            else {
                toast.error(error?.response?.data?.message || "Something Went Wrong!");
            }
        }
    }

    const getPublishers = async () => {
        try {
            const response = await allPublisherApi(token);
            setPublishers([{ pub_name: "All" }, ...response?.data?.publishers]);
            setPublisher("All");

        } catch (error) {
            if (error?.response?.status == 403) {
                dispatch(removeToken());
                toast.error("Login Again!");
                navigate('/');
            }
            else {
                toast.error(error?.response?.data?.message || "Something Went Wrong!");
            }
        }
    }

    useEffect(() => {
        getServices();
        getPublishers();
    }, []);

    const handleServiceChange = (data) => {
        setService(data);
        if (data == "All") {
            setFilteredPublishers([]);
            return;
        }
        let service2 = services.filter((item) => item?.service_name == data);
        let publishers2 = publishers.filter((item) => item?.service_id == service2?.[0]?.id);
        console.log(publishers2, 'p2');
        setFilteredPublishers([{ pub_name: "All" }, ...publishers2]);
    }

    const handlePublisherChange = (data) => {
        setPublisher(data);
    }

    const handleFormSubmission = async () => {
        try {
            const response = await getSubscriptionApi({
                service_name:service, pub_name:publisher, start_date:startDate, end_date:endDate
            }, token);
            setSubscription(response?.data?.result)
            console.log(response,'response...');
        } catch (error) {
            console.log(error, 'error===')
            if (error?.response?.status == 403) {
                dispatch(removeToken());
                toast.error("Login Again!");
                navigate('/');
            }
            else {
                toast.error(error?.response?.data?.message || "Something Went Wrong!");
            }
        }
    }

    useEffect(() => {
        if(service && publisher && startDate && endDate){
            handleFormSubmission();
        }
    }, [service, publisher, startDate, endDate]);

    return (
        <>
            <Layout active={2}>
                {loading ?
                    <>
                        <Spinner />
                    </>
                    : (
                        <>
                            <form className={classes.dropdown_containers}
                            >
                                <Dropdown
                                    value={service}
                                    onChange={(e) => handleServiceChange(e.value)}
                                    options={services?.map((data) => ({
                                        label: data?.service_name,
                                        value: data?.service_name,
                                    }))}
                                    placeholder="Select a Service"
                                    className={classes.dropdown}
                                />

                                <Dropdown
                                    value={publisher}
                                    onChange={(e) => handlePublisherChange(e.value)}
                                    options={(filteredPublishers.length > 0 ? filteredPublishers : publishers)?.map((data) => ({
                                        label: data?.pub_name,
                                        value: data?.pub_name,
                                    }))}
                                    placeholder="Select a Publisher"
                                    className={classes.dropdown}

                                />

                                <Calendar
                                    value={startDateForCalendar}
                                    onChange={(e) => convertStartDate(e.value)}
                                    showIcon
                                    placeholder="Start Date"
                                    className={classes.dropdown}
                                />

                                <Calendar
                                    value={endDateForCalendar}
                                    onChange={(e) => convertEndDate(e.value)}
                                    showIcon
                                    placeholder="End Date"
                                    className={classes.dropdown}

                                />

                                <button type="button" onClick={handleFormSubmission} className={classes.search_btn}>
                                    Search
                                </button>
                            </form>

                            <Message severity="info" text="Publisher Subscription" style={{ width: "100%", background: "none", border: "2px solid #E6F0FE", padding: "14px 10px", justifyContent: "flex-start" }} />

                            {subscription ? (
                                <div className={classes.table_container}>
                                    <DataTable
                                        value={subscription}
                                        emptyMessage="No data found"
                                        showGridlines
                                        responsive
                                        scrollable
                                        scrollHeight="500px"
                                        rows={15}
                                        paginator
                                    >
                                        <Column field="pub_name" header="Publisher" />
                                        <Column field="service_name" header="Service" />
                                        <Column field="queue" header="Queue" />
                                        <Column field="sent" header="Sent" />
                                        <Column field="skip" header="Skip" />
                                        <Column field="total" header="Total" />
                                    </DataTable>
                                </div>
                            ) : null}
                        </>
                    )}
            </Layout>
        </>
    )
}

export default SubscriptionPage